import { SubjectData } from 'shell/models/person';
import { AccordionMarriage as MarriageVM } from 'shell/view-models/accordion-marriage';
import { ActManagementForm } from 'shell/view-models/act-form';
import { transformMarriage } from './marriage';
import { ActType } from 'shell/constants/act-type';
import { DateTime } from 'luxon';

export type AccordionMarriageAnpr05 = Omit<MarriageVM, 'digital'> & ActManagementForm;

export const transformMarriageActAnpr05 = (
  person: SubjectData
): AccordionMarriageAnpr05 | undefined => {
  const marriage = transformMarriage(person);

  const isDigital = Boolean(person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC);

  const isPaper = Boolean(person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto);

  const result = marriage
    ? {
        ...marriage,
        actType: isDigital
          ? ActType.AttoDigitale
          : isPaper
          ? ActType.AttoCartaceo
          : ActType.SenzaAtto,
        digital: isDigital
          ? {
              nationalNumber:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.idANSC?.split('-')[1],
              documentDate: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC
                ?.dataFormazioneAtto
                ? DateTime.fromISO(
                    person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.dataFormazioneAtto
                  )
                : null,
              idAnsc: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.idANSC || '',
              istatCode:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                  ?.codiceIstat || '',
              municipality: {
                id:
                  person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.codiceIstat || '',
                description:
                  person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.nomeComune || '',
                province:
                  person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                    ?.siglaProvinciaIstat || '',
              },
              numberMunicipality:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.numeroComunale || '',
              year: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.anno || '',
              transcript:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.attoANSC?.trascritto === '1'
                  ? true
                  : false,
            }
          : undefined,
        paper: isPaper
          ? {
              // paper
              actMunicipality: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto
                ?.comuneRegistrazione
                ? {
                    description:
                      person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
                        ?.nomeComune || '',
                    province:
                      person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
                        ?.siglaProvinciaIstat || '',
                    id:
                      person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.comuneRegistrazione
                        ?.codiceIstat || '',
                  }
                : undefined,
              actYear: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.anno || '',
              actNumber: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.numeroAtto || '',
              actPart: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.parte || '',
              actSeries: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.serie || '',
              actVolume: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.volume || '',
              actDate: person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.dataFormazioneAtto
                ? DateTime.fromISO(
                    person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.dataFormazioneAtto
                  )
                : null,
              transcribed:
                person.matrimonio?.datiMatrimonio?.attoEventoANPR?.atto?.trascritto === '1'
                  ? true
                  : false,
            }
          : undefined,
      }
    : undefined;

  return result;
};
